module.exports = __webpack_public_path__ + "assets/new-mail.328e84fc.svg";